import { render, staticRenderFns } from "./HotelsGuestRoomSelector.vue?vue&type=template&id=7452d60c"
import script from "./HotelsGuestRoomSelector.vue?vue&type=script&lang=js"
export * from "./HotelsGuestRoomSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports